import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type OpenInNewProps = IconComponentBaseProps;

export const OpenInNew = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.blue[6],
}: OpenInNewProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4093_28"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="13"
      >
        <rect y="0.5" width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4093_28)">
        <path
          d="M2.65387 10.75C2.40129 10.75 2.1875 10.6625 2.0125 10.4875C1.8375 10.3125 1.75 10.0987 1.75 9.84613V3.15387C1.75 2.90129 1.8375 2.6875 2.0125 2.5125C2.1875 2.3375 2.40129 2.25 2.65387 2.25H5.43262C5.53904 2.25 5.62817 2.28592 5.7 2.35775C5.77175 2.4295 5.80762 2.51858 5.80762 2.625C5.80762 2.73142 5.77175 2.8205 5.7 2.89225C5.62817 2.96408 5.53904 3 5.43262 3H2.65387C2.61537 3 2.58013 3.01604 2.54813 3.04812C2.51604 3.08012 2.5 3.11537 2.5 3.15387V9.84613C2.5 9.88462 2.51604 9.91988 2.54813 9.95188C2.58013 9.98396 2.61537 10 2.65387 10H9.34613C9.38462 10 9.41988 9.98396 9.45188 9.95188C9.48396 9.91988 9.5 9.88462 9.5 9.84613V7.06738C9.5 6.96096 9.53592 6.87183 9.60775 6.8C9.6795 6.72825 9.76858 6.69238 9.875 6.69238C9.98142 6.69238 10.0705 6.72825 10.1423 6.8C10.2141 6.87183 10.25 6.96096 10.25 7.06738V9.84613C10.25 10.0987 10.1625 10.3125 9.9875 10.4875C9.8125 10.6625 9.59871 10.75 9.34613 10.75H2.65387ZM9.5 3.52688L5.12313 7.90387C5.05387 7.97304 4.96683 8.00846 4.862 8.01013C4.75725 8.01171 4.66863 7.97629 4.59613 7.90387C4.52371 7.83137 4.4875 7.74354 4.4875 7.64038C4.4875 7.53721 4.52371 7.44938 4.59613 7.37687L8.97312 3H7.375C7.26858 3 7.1795 2.96408 7.10775 2.89225C7.03592 2.8205 7 2.73142 7 2.625C7 2.51858 7.03592 2.4295 7.10775 2.35775C7.1795 2.28592 7.26858 2.25 7.375 2.25H9.798C9.92692 2.25 10.0345 2.29312 10.1206 2.37937C10.2069 2.46554 10.25 2.57308 10.25 2.702V5.125C10.25 5.23142 10.2141 5.3205 10.1423 5.39225C10.0705 5.46408 9.98142 5.5 9.875 5.5C9.76858 5.5 9.6795 5.46408 9.60775 5.39225C9.53592 5.3205 9.5 5.23142 9.5 5.125V3.52688Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
